"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PharmacyList = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const Pharmacy_service_1 = __importDefault(require("../../../../services/Pharmacy.service"));
const atome_1 = require("../../../atome");
const PharmacyList_styles_1 = require("./PharmacyList.styles");
const PremiumPharmacy_1 = require("./PharmacyComponent/PremiumPharmacy");
const VerifiedPharmacy_1 = require("./PharmacyComponent/VerifiedPharmacy");
const StandardPharmacy_1 = require("./PharmacyComponent/StandardPharmacy");
const hooks_1 = require("../../../../store/hooks");
const reducers_1 = require("../../../../store/reducers");
const PharmacyList = ({ navigation }) => {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const pharmaciesRedux = (0, hooks_1.useAppSelector)(reducers_1.selectPharmacies);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [showButton, setShowButton] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        if (pharmaciesRedux.length === 0) {
            setLoading(true);
            (async () => {
                const pharmaciesResult = await Pharmacy_service_1.default.getPharmacies('1');
                dispatch((0, reducers_1.setPharmacies)(pharmaciesResult.data));
                setLoading(false);
            })();
        }
    }, [pharmaciesRedux]);
    const loadMorePharmacies = async () => {
        setLoading(true);
        const pharmaciesVerified = await Pharmacy_service_1.default.getPharmacies('2');
        const pharmaciesStandard = await Pharmacy_service_1.default.getPharmacies('3');
        const allPharmacies = [
            ...pharmaciesRedux,
            ...pharmaciesVerified.data,
            ...pharmaciesStandard.data,
        ];
        dispatch((0, reducers_1.setPharmacies)(allPharmacies));
        setShowButton(false);
        setLoading(false);
    };
    const Pharmacies = () => (react_1.default.createElement(react_1.default.Fragment, null, pharmaciesRedux.length > 0 &&
        pharmaciesRedux.map(pharmacy => pharmacy.category === 1 ? (react_1.default.createElement(PremiumPharmacy_1.PremiumPharmacy, { key: pharmacy.id, navigation: navigation, pharmacy: pharmacy })) : pharmacy.category === 2 ? (react_1.default.createElement(VerifiedPharmacy_1.VerifiedPharmacy, { key: pharmacy.id, navigation: navigation, pharmacy: pharmacy })) : (react_1.default.createElement(StandardPharmacy_1.StandardPharmacy, { key: pharmacy.id, navigation: navigation, pharmacy: pharmacy })))));
    if (loading) {
        return react_1.default.createElement(atome_1.Loading, null);
    }
    return (react_1.default.createElement(atome_1.ProtectedPage, { navigation: navigation },
        react_1.default.createElement(react_native_1.SafeAreaView, { style: [PharmacyList_styles_1.styles.whiteBackground] },
            react_1.default.createElement(react_native_1.ScrollView, null,
                react_1.default.createElement(react_native_1.View, { style: PharmacyList_styles_1.styles.containerMobile },
                    react_1.default.createElement(atome_1.Icon, { icon: "pharmacy", size: 90 }),
                    react_1.default.createElement(react_native_1.View, { style: PharmacyList_styles_1.styles.textView },
                        react_1.default.createElement(atome_1.Text, { style: [PharmacyList_styles_1.styles.heading3Green] }, "Bitte w\u00E4hlen Sie Ihre Apotheke"),
                        react_1.default.createElement(atome_1.Text, { style: [PharmacyList_styles_1.styles.heading4] }, "Sollte Ihre gew\u00FCnschte Apotheke nicht in der Liste sein, k\u00F6nnen Sie unter \u201EWeitere Apotheken\u201C Ihre Apotheke eingeben.")),
                    react_1.default.createElement(Pharmacies, null),
                    react_1.default.createElement(atome_1.Text, { style: [
                            PharmacyList_styles_1.styles.morePharmaciesText,
                            !showButton && { display: 'none' },
                        ], onPress: () => loadMorePharmacies() }, "Weitere Apotheken"),
                    react_1.default.createElement(react_native_1.View, { style: [PharmacyList_styles_1.styles.textView, showButton && { display: 'none' }] },
                        react_1.default.createElement(atome_1.Text, { style: [PharmacyList_styles_1.styles.heading3Green] }, "Apotheke nicht gefunden?"),
                        react_1.default.createElement(atome_1.Text, { style: [PharmacyList_styles_1.styles.heading4] }, "Teilen Sie uns den Namen und die Anschrift Ihrer gew\u00FCnschten Apotheke mit und wir k\u00FCmmern uns um den Rest"),
                        react_1.default.createElement(react_native_1.Pressable, { style: PharmacyList_styles_1.styles.button, onPress: () => navigation.navigate('PharmacyCreation'), disabled: false },
                            react_1.default.createElement(atome_1.Text, { style: [PharmacyList_styles_1.styles.buttonText] }, "Apotheke eingeben"))))))));
};
exports.PharmacyList = PharmacyList;
